export default "__VITE_ASSET__Haf9sdQR__"